var _module_exports = "<div>\r\n    The buyer has indicated roughly how much they are willing to pay. Parts sellers and buyers should always confirm this amount before proceeding with a transaction.\r\n</div>";;
var path = 'partswantedlisting/wtp-template.html';
window.angular.module('row52-templates').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;